import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { REGION_MODAL_TEXTS } from "../../consts";
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var ContentWrapper = function ContentWrapper(_ref) {
  var className = _ref.className,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('content-wrapper', className)
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('title', className),
    color: "primary-invert",
    lineHeight: 36,
    size: 32
  }, REGION_MODAL_TEXTS.title), children);
};